export default "__VITE_ASSET__oUKC5CMd__"